export const getAuthHeaders = (extra = {}) => ({
    headers: { 'Authorization': `Bearer ${localStorage.getItem("tokenRestaurant")}` },
    ...extra
});